<template>
  <div>
    <h4 class="text-green mt_15 mb_10">建議明細</h4>
    <ItemIV :contractData="detailData" />

    <h4 class="text-green mt_15 mb_10">{{ titleText }}</h4>

    <div class="fund mb_5 fund_table">
      <template v-if="showFundTitle">
        <div class="fund__header" v-if="!is_base1">
          <div>{{ fund_header_text }}</div>
        </div>
        <div class="fund__title">
          <div>基金代碼</div>
          <div>
            基金名稱與介紹
            <span v-if="isNAP" class="fund__title--nap"
              >(可長按網址打開連結)</span
            >
          </div>
          <div>幣別</div>
          <div>風險等級</div>
          <div>適合<br />風險屬性</div>
          <div>投資比例</div>
        </div>
        <!-- 基金標的 -->
        <template v-for="(fund, index) in showFundList">
          <div class="fund__item" :key="'fund_' + index">
            <div>{{ fund.fund_id }}</div>
            <div class="text-left flex-column">
              <div class="w-100 text-left">{{ fund.fund_c_name }}</div>
              <div>
                <a :href="fundLink(fund)" target="_blank">{{
                  fundLink(fund)
                }}</a>
              </div>
            </div>
            <div>{{ fund.curr }}</div>
            <div>{{ fund.risk_lvl }}</div>
            <div>{{ fund.kyc_risk_lvl }}</div>
            <div>{{ fund.fund_proportion }}%</div>
          </div>
        </template>
      </template>

      <template v-else>
        <div class="fund__allocation__title">
          <div>帳戶種類</div>
          <div>比例</div>
          <div>回饋分享金給付帳戶</div>
        </div>
        <template v-for="(fund, index) in showFundList">
          <div class="fund__allocation__item" :key="'fund_' + index">
            <div>{{ fund.fund_c_name }}</div>
            <div>{{ fund.fund_proportion }}%</div>
            <div>{{ getDvdKindText(fund) }}</div>
          </div>
        </template>
      </template>

      <div class="fund__footer">
        <div
          v-for="(rmk, index) in remark_list"
          :key="index"
          v-html="rmk.content"
          class="fund__footer__content"
        ></div>
      </div>
    </div>
    <div class="fund mb_5 fund_table" v-if="showFundExtra">
      <div class="fund__header">
        <div>{{ fund_extra_header_text }}</div>
      </div>
      <div class="fund__title">
        <div>基金代碼</div>
        <div>
          基金名稱與介紹
          <span v-if="isNAP" class="fund__title--nap"
            >(可長按網址打開連結)</span
          >
        </div>
        <div>幣別</div>
        <div>風險等級</div>
        <div>適合<br />風險屬性</div>
        <div>投資比例</div>
      </div>

      <template v-for="(fund, index) in showFundExtraList">
        <div class="fund__item" :key="'fund_extra_' + index">
          <div>{{ fund.fund_id }}</div>
          <div class="text-left flex-column">
            <div class="w-100 text-left">{{ fund.fund_c_name }}</div>
            <div>
              <a :href="fundLink(fund)" target="_blank">{{ fundLink(fund) }}</a>
            </div>
          </div>
          <div>{{ fund.curr }}</div>
          <div>{{ fund.risk_lvl }}</div>
          <div>{{ fund.kyc_risk_lvl }}</div>
          <div>{{ fund.fund_proportion }}%</div>
        </div>
      </template>

      <div class="fund__footer">
        <div
          v-for="(rmk, index) in remark_extra_list"
          :key="index"
          v-html="rmk.content"
          class="fund__footer__content"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import ItemIV from "@/desktop/views/mf/components/2.Query/2-1-1.CreateDetail/Item_IV.vue";
import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  components: { ItemIV },
  mixins: [mf_Mixin],

  data() {
    return {
      detailData: null,
      fund_target_rmk_prod_list: [],
      fund_target_rmk_common_list: [],
      ready: false,
      remark_list: "",
      remark_extra_list: [],
      is_base1: false,
      showFundList: [],
      fund_header_text: "一般投資標的",
      fund_extra_header_text: "額外指定投資標的",
      showFundExtraList: [], //永續標的
    };
  },
  computed: {
    MfViewing() {
      return this.$store.getters.MfViewing;
    },
    is_crm() {
      return this.MfViewing.inputType == "noId" ? "0" : "1";
    },
    isBankUser() {
      return this.$store.getters.IsBankUser;
    },
    isNAP() {
      return this.$store.state.userInfo.userType === "box" && !this.isBankUser;
    },
    fund_type() {
      return this.MfViewing.mc_prod_list[0].FEATURE_DATA.fund_type;
    },
    titleText() {
      return this.fund_type !== "5" ? "投資標的組合與介紹" : "帳戶比例配置約定";
    },
    showFundTitle() {
      return this.fund_type !== "5";
    },
    showFundExtra() {
      return !this.is_base1 && this.fund_type !== "5";
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.detailData = this.MfViewing;
      this.is_base1 = this.fund_type == "1";
      if (this.fund_type == "4") {
        this.MfViewing.mc_prod_list[0].fund.fund.forEach((item) => {
          this.showFundList.push(item);
        });
        this.MfViewing.mc_prod_list[0].fund.fund_extra.forEach((item) => {
          this.showFundExtraList.push(item);
        });
      } else {
        for (let keyName in this.MfViewing.mc_prod_list[0].fund) {
          this.MfViewing.mc_prod_list[0].fund[keyName].forEach((item) => {
            this.showFundList.push(item);
          });
        }
      }
      //處理基金標的

      //處理備註
      this.$mfAPI
        .MFB1_1150__queryFundTargetRmkData({
          prod_id: this.MfViewing.mc_prod_list[0].prod_id,
        })
        .then((res) => {
          let {
            fund_target_rmk_prod_list,
            fund_target_rmk_common_list,
            fund_extra_target_rmk_prod_list,
          } = res;
          this.fund_target_rmk_prod_list = fund_target_rmk_prod_list;
          this.fund_target_rmk_common_list = fund_target_rmk_common_list;
          let remark_list = [];
          this.fund_target_rmk_common_list.forEach((item) => {
            if (item.isChecked == "1") {
              remark_list.push({ content: item.content });
            }
          });
          this.fund_target_rmk_prod_list.forEach((item) =>
            remark_list.push({ content: item.content })
          );
          this.remark_list = remark_list;
          if (fund_extra_target_rmk_prod_list) {
            fund_extra_target_rmk_prod_list.forEach((item) =>
              this.remark_extra_list.push({ content: item.content })
            );
          }
          this.ready = true;
          setTimeout(() => {
            this.registerHanlink();
          }, 50);
        });
    },
    fundLink(fund) {
      return this.isBankUser ? fund.fund_url2 : fund.fund_url;
    },
    getDvdKindText(fund) {
      if (!fund.dvd_kind) {
        return "---";
      }
      return this.$paragrpno.dvd_kind
        .filter((item) => item.paraval === fund.dvd_kind)
        .map((item) => item.paradetlno)[0];
    },
  },
};
</script>

<style lang="scss">
.fund {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #53c480;
  &__header {
    width: 100%;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border: solid 0.5px rgba(194, 196, 199, 0.8);
    font-size: 18px !important;
    padding: 3px 7px;
  }
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    &--nap {
      width: 100%;
      font-size: 13px;
      text-align: center;
      color: #de4054;
    }
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 3px 7px;
      flex-wrap: wrap;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 10%;
    }
    & > div:nth-of-type(2) {
      width: 10%;
    }
    & > div:nth-of-type(3) {
      width: 40%;
    }
    & > div:nth-of-type(4) {
      width: 10%;
    }
    & > div:nth-of-type(5) {
      width: 10%;
    }
    & > div:nth-of-type(6) {
      width: 10%;
    }
  }
  //主約
  &__item {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #fff;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 10%;
    }
    & > div:nth-of-type(2) {
      width: 10%;
    }
    & > div:nth-of-type(3) {
      width: 40%;
    }
    & > div:nth-of-type(4) {
      width: 10%;
    }
    & > div:nth-of-type(5) {
      width: 10%;
    }
    & > div:nth-of-type(6) {
      width: 10%;
    }
  }
  &__footer {
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    line-height: 1.38;
    padding: 8px 10px;
    &__content span {
      font-size: 16px !important;
    }
  }
  &.fund_table {
    // 共用子元素樣式
    %fund-table-child-style {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 3px 7px;
    }

    .fund__title,
    .fund__item {
      & > div {
        @extend %fund-table-child-style;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 10%;
      }
      & > div:nth-of-type(2) {
        width: 50%;
      }
      & > div:nth-of-type(3),
      & > div:nth-of-type(4),
      & > div:nth-of-type(5),
      & > div:nth-of-type(6) {
        width: 10%;
      }
    }

    .fund__allocation__title,
    .fund__allocation__item {
      display: flex;

      & > div {
        @extend %fund-table-child-style;
        min-height: 50px;
      }
      & > div:nth-of-type(1) {
        width: 40%;
      }
      & > div:nth-of-type(2) {
        width: 30%;
      }
      & > div:nth-of-type(3) {
        width: 30%;
        flex-grow: 1;
      }
    }

    .fund__allocation__title {
      font-weight: 700;
      color: #027a39;
      background-color: #e5f6ec;
    }
  }
}
</style>
